import { getTranspiledDatasetsData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useDatasetsData = (transpilerId: string, isBulk?: boolean, disabled?: boolean) => {
  const data = useRestQuery(
    [QueryKey, 'getDatasetsTranspiledData', transpilerId],
    () => getTranspiledDatasetsData(transpilerId, isBulk),
    {
      retry: false,
      refetchOnMount: true,
      enabled: !!transpilerId && !disabled,
      sentryTag: 'transpiler.getDatasetsTranspiledData'
    }
  );

  return data;
};
